import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { getTeams } from "store/team/actions";

import { getTags } from "./actions";

export const tagAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = tagAdapter.getInitialState({
  count: 0,
  modals: {},
  countByCategory: {},
});

export const tagSlice = createSlice({
  name: "tag",
  initialState,
  reducers: {
    showPlayerAddModal: (state, action) => {
      state.modals.playerAddModal = action.payload;
    },
    showPlayerDeleteModal: (state, action) => {
      state.modals.playerDeleteModal = action.payload;
    },
    resetTagState: () =>
      tagAdapter.getInitialState({
        count: 0,
        modals: {},
        countByCategory: {},
      }),
  },
  extraReducers: (builder) => {
    builder.addCase(getTags.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.entities.tag) {
        if (action.meta.arg.requestType === "append") {
          tagAdapter.addMany(state, action.payload.entities.tag);
        } else {
          tagAdapter.setAll(state, action.payload.entities.tag);
        }
        state.count = action.payload.totalCount || 0;
        state.countByCategory[action.meta.arg.payload.category] = action.payload.totalCount || 0;
      } else {
        tagAdapter.removeAll(state);
        state.count = 0;
      }
    });

    builder.addCase(getTeams.fulfilled, (state, action) => {
      if (action.payload.entities?.tag) {
        tagAdapter.setAll(state, action.payload.entities.tag);
      }
    });
  },
});

export const { showPlayerAddModal, showPlayerDeleteModal, resetTagState } = tagSlice.actions;

export default tagSlice.reducer;
